import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

export interface DropdownItem {
  routerLink: string[];
  translationKey: string;
}

export interface NavigationItem {
  routerLink: string[];
  translationKey: string;
  requiredPermission?: bigint[];
}

@Component({
  selector: 'app-header-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class HeaderSidebarComponent {
  isOpen = input<boolean>(false);
  language = input<string>('ar');
  isLoggedIn = input<boolean>(false);
  userName = input<string>('');
  userAvatar = input<string>('images/Avatar.png');
  showUserMenu = input<boolean>(false);
  isExpanded = input<boolean>(false);
  dropdownItems = input<DropdownItem[]>([]);
  navigationItems = input<NavigationItem[]>([]);
  hasPermission = input<(permissions: bigint[]) => boolean>(() => true);

  close = output<void>();
  toggleUserMenu = output<void>();
  closeUserMenu = output<void>();
  toggleDropdown = output<void>();
  changeLanguage = output<void>();
  logout = output<void>();

  onBackdropClick(): void {
    this.close.emit();
  }

  onToggleUserMenu(): void {
    this.toggleUserMenu.emit();
  }

  onCloseUserMenu(): void {
    this.closeUserMenu.emit();
  }

  onToggleDropdown(): void {
    this.toggleDropdown.emit();
  }

  onChangeLanguage(): void {
    this.changeLanguage.emit();
  }

  onLogout(): void {
    this.logout.emit();
  }

  onLinkClick(): void {
    this.close.emit();
  }
}
